import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj, PAYMENT_METHODS } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { IProgram } from 'src/app/interfaces/country';
import { pageKey, toNumber } from 'src/app/services/mapping.service';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-program',
  templateUrl: './add-program.component.html',
  styleUrls: ['./add-program.component.scss']
})
export class AddProgramComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  name: AbstractControl;
  paymentMethod: AbstractControl;
  description: AbstractControl;
  program: AbstractControl;
  order: AbstractControl;

  PROGRAMTYPES: Array<any> = [];
  PAYMENTMENTHOD = PAYMENT_METHODS

  constructor(public dialogRef: MatDialogRef<AddProgramComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
        public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public store: List
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      paymentMethod: [PAYMENT_METHODS[0], Validators.compose([Validators.required])],
      name: [null, Validators.required],
      description: [null],
      program: [null, Validators.required],
      order: [null, Validators.required]
    });
    this.paymentMethod = this.form.controls['paymentMethod'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.program = this.form.controls['program'];
    this.order = this.form.controls["order"]
  }

  async ngOnInit() {
    this.buildForm();
    this.PROGRAMTYPES = await this.store.fetchList(this.ds.degreeRef(ref => ref.orderBy('order')))

    this.form.patchValue({
      program: this.PROGRAMTYPES.length > 0 ? this.PROGRAMTYPES[0] : null
    })
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { paymentMethod, name, description, program, order } = f;
      const { levelKey,key } = program;
      const item: IProgram = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        description: description,
        degreeRef: this.ds.degreeRef().doc(`${key}`).ref,
        degreeKey: key,
        status: statusObj.active,
        paymentMethod: paymentMethod,
        order: toNumber(order),
        levelKey: levelKey,
        levelRef: this.ds.levelRef().doc(`${levelKey}`).ref,
      };

      this.store.save(this.ds.adprogramRef(), item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Program has been created successfully.', 'done', { duration: 2000 });
          this.form.reset();
          this.form.patchValue({
            program, paymentMethod
          });
          this.inputEl.nativeElement.focus();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });
    }
  }

}
